module.exports = __webpack_public_path__ + "static/klay-79a2b48cc0431d3fac9252b666bc2e6f.png";